import { Box, Typography, useTheme } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

const Logo = ({ variant = 'default' }: { variant?: 'default' | 'sidebar' }) => {
  const theme = useTheme();
  const { t } = useLanguage();
  
  return (
    <Box 
      display="flex" 
      alignItems="center"
      sx={{
        textDecoration: 'none',
        '&:hover': {
          '& .logo-text': {
            background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          },
        },
      }}
    >
      <Typography
        className="logo-text"
        variant={variant === 'sidebar' ? 'h5' : 'h6'}
        sx={{
          fontWeight: 800,
          letterSpacing: '0.5px',
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          transition: 'all 0.3s ease',
          fontSize: variant === 'sidebar' ? '1.5rem' : '1.25rem',
          lineHeight: 1.2,
        }}
      >
        GoExpress
      </Typography>
      <Box 
        sx={{
          ml: 1,
          px: 1,
          py: 0.5,
          borderRadius: 2,
          backgroundColor: 'rgba(67, 97, 238, 0.1)',
          color: theme.palette.primary.main,
          fontSize: '0.6rem',
          fontWeight: 700,
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          display: variant === 'sidebar' ? 'block' : 'none',
        }}
      >
        {t('dashboard.title')}
      </Box>
    </Box>
  );
};

export default Logo;
